import { FrontNotification, FrontNotificationType, NotificationCards } from '@/data'
import { v4 as uuidv4 } from 'uuid'
import { AppDispatch } from '@/store/context'
import { NotificationsTypes } from './NotificationsReducer'
import { BasicAuthServiceHelper } from '@/modules/Auth'
import { GetNotificationCards } from './apiTypes'

export type NotificationContent<T> = Omit<FrontNotification<T>, 'id' | 'date'>

export const addNotification =
  (dispatch: AppDispatch) =>
  <T>({ type, title, message, extra, timeToStay, action }: NotificationContent<T>): void => {
    dispatch({
      type: NotificationsTypes.Add,
      payload: { type, title, message, extra, timeToStay, action, id: uuidv4() },
    })
    switch (type) {
      case FrontNotificationType.ERROR: {
        console.error(`##Notif: ${title} - ${message}`, extra)
        break
      }
      case FrontNotificationType.WARN: {
        console.warn(`##Notif: ${title} - ${message}`, extra)
        break
      }
      case FrontNotificationType.SUCCESS: {
        console.log(`##Notif: ${title} - ${message}`, extra)
        break
      }
      default: {
        console.debug(`##Notif: ${title} - ${message}`, extra)
        break
      }
    }
  }

export const closeNotification =
  (dispatch: AppDispatch) =>
  (id: string): void => {
    dispatch({ type: NotificationsTypes.Remove, payload: id })
  }

// CLEANUP
// *********************
export const cleanup = (dispatch: AppDispatch) => (): void => {
  dispatch({ type: NotificationsTypes.Cleanup, payload: null })
}

/* *******************************
  Get Notification Cards
******************************* */

export const getNotificationCards = async (): Promise<NotificationCards> => {
  return await BasicAuthServiceHelper.requestAuthenticatedV2Async<GetNotificationCards.Response>(
    GetNotificationCards.Route,
  )
}
